import React from 'react';

const SvgContainer = (svg: string): JSX.Element => <img src={svg} alt="icon" />;

export default SvgContainer;